// src/theme.js

const theme = {
  colors: {
    topStripBackground: "#fcfcfc",
    topStripText: "#000000",
    primary: "#007bff",  // Example primary color
    secondary: "#6c757d", // Example secondary color
    accent: "#28a745",    // Example accent color
    // Add more colors as needed
    cardBackground: "#D9D9D9",
    cardBodyBackground: "#f2f2f2",
    vpNameColor: "#000000",
    vpDesignationColor: "#444242",
    vpQuoteColor: "#484848",
  },
  downloads:{
    backgroundColor: "rgba(241, 65, 68, 0.57)",
    textColor:"#000000",
    bordercolor: 'transparent'
  },
  card: {
    borderRadius: "10px",
    bodyBorderRadius: "15px",
    dropShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Drop shadow effect
    spacing: "1rem", // Space between cards
    width: "90%", // Reduced width of cards
  },
  text: {
    vpName: {
      fontWeight: "bold",
      fontSize: "20px",
    },
    vpDesignation: {
      fontWeight: "bold",
      fontSize: "10px",
    },
    vpQuote: {
      fontWeight: 600,
      fontSize: "14px",
    },
  },
};

export default theme;
